import { render, staticRenderFns } from "./HusbandryRoomActivityReportDayRoomUser.vue?vue&type=template&id=51a61c54&scoped=true&"
import script from "./HusbandryRoomActivityReportDayRoomUser.vue?vue&type=script&lang=js&"
export * from "./HusbandryRoomActivityReportDayRoomUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a61c54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VRow})
